import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FeaturesCtx = createContext({ flags: {}, loading: true, refresh: () => {} });

const FALLBACK = {
    ai_assistant: true,
    ai_summary: true,
    automations: true,
    client_portal: true,
    communications_email: true,
    communications_whatsapp: true,
    razorpay_payments: true,
    white_label: false,
    webauthn_login: true,
};

export function FeaturesProvider({ children }) {
    const { user } = useAuth();
    const [flags, setFlags] = useState(FALLBACK);
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!user || user.role === "super_admin" || user.role === "client_portal") {
            setFlags(FALLBACK);
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.get("/features");
            setFlags({ ...FALLBACK, ...data });
        } catch {
            setFlags(FALLBACK);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <FeaturesCtx.Provider value={{ flags, loading, refresh }}>
            {children}
        </FeaturesCtx.Provider>
    );
}

export const useFeatures = () => useContext(FeaturesCtx);
